import { SharedState } from '@trello/shared-state';

import { getRouteIdFromPathname } from './getRouteIdFromPathname';
import { getRouteParamsFromPathname } from './getRouteParamsFromPathname';
import type { RouteIdType, Routes } from './routes';

export interface LocationState {
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
  origin: string;
}

export interface RouterState<T extends RouteIdType> {
  id: RouteIdType;
  params: ReturnType<Routes[T]['getRouteParams']>;
  location: LocationState;
}

const { pathname, search, hash, hostname, origin } = window.location;

export const routerState = new SharedState<RouterState<RouteIdType>>({
  // eslint-disable-next-line @trello/no-module-logic
  id: getRouteIdFromPathname(pathname),
  // eslint-disable-next-line @trello/no-module-logic
  params: getRouteParamsFromPathname<RouteIdType>(pathname),
  location: {
    hostname,
    pathname,
    search,
    hash,
    origin,
  },
});
